var getCompVarPrefix = function getCompVarPrefix(component, prefix) {
  return "".concat([prefix, component.replace(/([A-Z]+)([A-Z][a-z]+)/g, '$1-$2').replace(/([a-z])([A-Z])/g, '$1-$2')].filter(Boolean).join('-'));
};
export default getCompVarPrefix;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ant-design/cssinjs-utils/es/util/getCompVarPrefix.js
// module id = 1476
// module chunks = 0